module.exports = __webpack_public_path__ + "img/ani-9.ebc51237.png";